import type { GuideCommand } from "@asurion-core/expert-workspace-timeline";
import type { ReactNode } from "react";

import { Flex } from "@mantine/core";
import { ErrorBoundary } from "react-error-boundary";

import { InlineGuidedFlowsPanel } from "@/components/workspace/GuidedFlowsPanel";
import { UI_ORCHESTRATION_COMPONENT } from "@/expert-hub/data/expertHubErrorMetric";
import { useLogger } from "@/sdk/logging/LoggerProvider";
import { trackedBoundaryProps } from "@/shared-utils";
import { PlatformTimeline } from "@/timeline";

export interface AssistTabProps {
    /** The open guide, rendered inline at the top of the tab. */
    guide: ReactNode;
    isGuideOpen: boolean;
    guideTitle: string;
    onGuideClose: () => void;
    /** Launches a guide from the Toolbox ("Launch guided flow" / `/g`). */
    guideToolboxCommand: GuideCommand;
}

export function AssistTab({ guide, isGuideOpen, guideTitle, onGuideClose, guideToolboxCommand }: AssistTabProps) {
    const logger = useLogger({ module: "AssistTab" });

    return (
        <Flex pos="absolute" inset={0} direction="column">
            {isGuideOpen && guide ? (
                <InlineGuidedFlowsPanel guide={guide} title={guideTitle} onClose={onGuideClose} />
            ) : null}
            <ErrorBoundary {...trackedBoundaryProps(logger, UI_ORCHESTRATION_COMPONENT)}>
                <PlatformTimeline guide={guideToolboxCommand} />
            </ErrorBoundary>
        </Flex>
    );
}
